import React from 'react';

var List = function List(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H8zm0-2h8a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm6 5a1 1 0 0 1 0 2h-4a1 1 0 1 1 0-2h4zm0 3a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h4zm0 3a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

List.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { List as icon };
export default iconHandler(List);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/List.js
// module id = 607
// module chunks = 0